<template>
  <div id="app">
    <div class="tecate00_loader" :style="{display: isLoaded?'none':'block'}">
      <div class="tecate00_loader_container">
        <div class="tecate00_lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
    <transition-group name="slide-fade">
      <template v-if="getAgeGateToken">
      <!--<template v-if="true">-->
        <router-view key="tecate00"></router-view>
      </template>
    </transition-group>
    <transition-group name="slide-fade">
      <template v-if="!getAgeGateToken">
      <!--<template v-if="false">-->
        <AgeGate key="agegate" />
      </template>
    </transition-group>
    <!-- <ModalAH v-show="showModal" wichModal="alcoholandhealth" @close="showModal = false"></ModalAH> -->
  </div>
</template>

<script>
import { mapActions, mapGetters  } from "vuex";

import AgeGate from "@/containers/AgeGatem";
// import ModalAH from "@/components/ModalAH.vue";

// const utm = {
//   utm_content: "QR_AvisoAlcohol",
//   utm_medium: "PopUp",
//   utm_source: "Lata-Tecate00",
// }

export default {
  name: "app",
  components: {
    AgeGate,
    // ModalAH,
  },
  data() {
    return {
      toggler: false,
      showModal: false,
    };
  },
  computed: {
    ...mapGetters(["getAgeGateToken", "isLoaded"]),
  },
  methods: {
    ...mapActions({
      setScrollMotionAction: "setScrollMotion",
      setEdgeScrollingAction: "setEdgeScrolling",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setLoadStatus: "setLoadStatus",
      setAgeGateTokenAction: "setAgeGateToken",
    }),
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.setScrollMotionAction("downEnd");
      } else if (scrollTop + clientHeight <= clientHeight + 5) {
        this.setScrollMotionAction("upStart");
      } else {
        this.setScrollMotionAction("scrolling");
      }
    },
  },
  mounted() {
    window.onload = () => {
      this.setLoadStatus({status: true})
    }
    this.$nextTick(() => {});
    // // console.log(this.$route.query)
    // const {utm_source, utm_medium, utm_content} = this.$route.query;
    // if((utm['utm_source'] === utm_source) && utm['utm_content'] === utm_content && utm['utm_medium'] === utm_medium ) {
    //   //console.log('show pop up')
    //   setTimeout(() => {
    //     this.showModal = true
    //   }, 3000);
    // }
    const body = document.querySelector('body');
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.innerHTML = `
    {
      "@context": "http://schema.org/",
    "@type": "Product",
    "name": "Tecate 0.0",
    "image": "https://tecate.com/tecate0.0/img/CAN_TECATE.9700a604.png",
    "description": "Nueva Tecate 0.0, sin alcohol, disfrutala con tus comidas. Hecha con el sabor original. Necesitas 0.0 pretextos para darle sabor a tus comidas. Tomala bien fría.",
    "brand": {
      "@type": "Brand",
      "name": "Tecate"
        },
	"offers": [
        {
            "@type": "Offer",
		    "priceCurrency": "MXN",
		    "price": "17",
		    "url": "https://www.glup.com/",
            "offeredBy": {
                "@type": "Organization",
                "@id": "https://www.glup.com/",
                "name": "Glup"
            },
		    "availability": "https://schema.org/InStock",
            "seller": {
                "@type": "Organization",
                "name": "Glup",
                "url":"https://www.glup.com/"
            }
        },
        {
            "@type": "Offer",
		    "priceCurrency": "MXN",
		    "price": "408",
		    "url": "https://articulo.mercadolibre.com.mx/MLM-1815188527-cerveza-sin-alcohol-tecate-00-24-latas-de-355ml-_JM",
            "offeredBy": {
                "@type": "Organization",
                "@id": "https://www.mercadolibre.com.mx/",
                "name": "Mercado Libre"
            },
		    "availability": "https://schema.org/InStock",
            "seller": {
                "@type": "Organization",
                "name": "Mercado Libre",
                "url":"https://articulo.mercadolibre.com.mx/MLM-1815188527-cerveza-sin-alcohol-tecate-00-24-latas-de-355ml-_JM"
            }
        },
        {
            "@type": "Offer",
		    "priceCurrency": "MXN",
		    "price": "14",
		    "url": "https://nuevo.chedraui.com.mx/cerveza-tecate-sin-alcohol-355ml-3769522/p",
            "offeredBy": {
                "@type": "Organization",
                "@id": "https://www.chedraui.com.mx/",
                "name": "Chedraui"
            },
		    "availability": "https://schema.org/InStock",
            "seller": {
                "@type": "Organization",
                "name": "Chedraui",
                "url":"https://nuevo.chedraui.com.mx/cerveza-tecate-sin-alcohol-355ml-3769522/p"
            }
        },
        {
            "@type": "Offer",
		    "priceCurrency": "MXN",
		    "price": "14",
		    "url": "https://www.lacomer.com.mx/lacomer/#!/detarticulo/7503032272436/0/732/1///732?succId=287&succFmt=100",
            "offeredBy": {
                "@type": "Organization",
                "@id": "https://www.lacomer.com.mx/lacomer/#!/home?succId=287&succFmt=100",
                "name": "La Comer"
            },
		    "availability": "https://schema.org/InStock",
            "seller": {
                "@type": "Organization",
                "name": "La Comer",
                "url":"https://www.lacomer.com.mx/lacomer/#!/detarticulo/7503032272436/0/732/1///732?succId=287&succFmt=100"
            }
        },
        {
            "@type": "Offer",
		    "priceCurrency": "MXN",
		    "price": "14",
		    "url": "https://www.heb.com.mx/cerveza-tecate-no-alcoholica-0-0-de-lata-355-ml-898460/p",
            "offeredBy": {
                "@type": "Organization",
                "@id": "https://www.heb.com.mx/",
                "name": "HEB"
            },
		    "availability": "https://schema.org/InStock",
            "seller": {
                "@type": "Organization",
                "name": "HEB",     "url":"https://www.heb.com.mx/cerveza-tecate-no-alcoholica-0-0-de-lata-355-ml-898460/p"
            }
        },
        {
            "@type": "Offer",
		    "priceCurrency": "MXN",
		    "price": "14",
		    "url": "https://super.walmart.com.mx/ip/bebida-no-alcoholica-tecate-cerveza-clara-0-0-alcohol-355-ml/00750303227243",
            "offeredBy": {
                "@type": "Organization",
                "@id": "https://super.walmart.com.mx/",
                "name": "Walmart"
            },
		    "availability": "https://schema.org/InStock",
            "seller": {
                "@type": "Organization",
                "name": "Walmart",
                "url":"https://super.walmart.com.mx/ip/bebida-no-alcoholica-tecate-cerveza-clara-0-0-alcohol-355-ml/00750303227243"
            }
        },
        {
            "@type": "Offer",
		    "priceCurrency": "MXN",
		    "price": "14",
		    "url": "https://www.soriana.com/cerveza-tecate-0.0-lata-355-ml/11688516.html",
            "offeredBy": {
                "@type": "Organization",
                "@id": "https://www.soriana.com/",
                "name": "Soriana"
            },
		    "availability": "https://schema.org/InStock",
            "seller": {
                "@type": "Organization",
                "name": "Soriana",
                "url":"https://www.soriana.com/cerveza-tecate-0.0-lata-355-ml/11688516.html"
            }
        }
    ],
	"aggregateRating": {
		"@type": "AggregateRating",
		"ratingValue" : "5",
		"ratingCount" : "100"
	}
    `;
    
    body.appendChild(script);
  },
};
</script>

<style lang="scss">
@import "./styles/main.scss";

.tecate00_loader {
  background: linear-gradient(
    180deg
    ,$grey 0,$grey 100%);
      position: fixed;
      top: 0;
      left: 0;
      display: block;
      height: 100%;
      height: 100vh;
      width: 100%;
      width: 100vw;
      overflow: hidden;
      z-index: 100000000000; 
  .tecate00_loader_container {
    position: absolute;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
    @media screen and (max-width: 768px) {
      top: 50%;
      left: 51%;
    }
    .tecate00_lds-default {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
    }
    .tecate00_lds-default div {
      position: absolute;
      width: 6px;
      height: 6px;
      background: #fff;
      border-radius: 50%;
      animation: tecate00_lds-default 1.2s linear infinite;
    }
    .tecate00_lds-default div:nth-child(1) {
      animation-delay: 0s;
      top: 37px;
      left: 66px;
    }
    .tecate00_lds-default div:nth-child(2) {
      animation-delay: -0.1s;
      top: 22px;
      left: 62px;
    }
    .tecate00_lds-default div:nth-child(3) {
      animation-delay: -0.2s;
      top: 11px;
      left: 52px;
    }
    .tecate00_lds-default div:nth-child(4) {
      animation-delay: -0.3s;
      top: 7px;
      left: 37px;
    }
    .tecate00_lds-default div:nth-child(5) {
      animation-delay: -0.4s;
      top: 11px;
      left: 22px;
    }
    .tecate00_lds-default div:nth-child(6) {
      animation-delay: -0.5s;
      top: 22px;
      left: 11px;
    }
    .tecate00_lds-default div:nth-child(7) {
      animation-delay: -0.6s;
      top: 37px;
      left: 7px;
    }
    .tecate00_lds-default div:nth-child(8) {
      animation-delay: -0.7s;
      top: 52px;
      left: 11px;
    }
    .tecate00_lds-default div:nth-child(9) {
      animation-delay: -0.8s;
      top: 62px;
      left: 22px;
    }
    .tecate00_lds-default div:nth-child(10) {
      animation-delay: -0.9s;
      top: 66px;
      left: 37px;
    }
    .tecate00_lds-default div:nth-child(11) {
      animation-delay: -1s;
      top: 62px;
      left: 52px;
    }
    .tecate00_lds-default div:nth-child(12) {
      animation-delay: -1.1s;
      top: 52px;
      left: 62px;
    }
  }
}

@keyframes tecate00_lds-default {
  0%, 20%, 80%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
</style>
